import axios from 'axios'
export default {
  getPublicConfig: () => axios.get('/config/public'),
  getPrivateConfig: () => axios.get('/config/private'),
  getCurrencies: () => axios.get('/currencies/with_exchanges'),
  getZohoPlans: () => axios.get('/zoho/plans')
}
